import { defineFeature } from '@/lib/platform/system';
import { clientMachine } from '@/features/client/state/client.machine';
import { rulePackageMachine } from '@/features/rule-package/state/rule-package.machine';
import { filingMachine } from '@/features/filing/state/filing.machine';
import { sourceBoxMachine } from '@/features/source-box/state/source-box.machine';
export const features = [
  defineFeature({
    id: 'client',
    machine: clientMachine,
    emits: ['client.opened'],
    handles: [],
    accepts: ['client.load-viewClients', 'client.open', 'client.open-dialog'],
  }),
  defineFeature({
    id: 'rule-package',
    machine: rulePackageMachine,
    emits: ['rule-package.published'],
    handles: [],
    accepts: ['rule-package.load-viewRulePackages', 'rule-package.publish', 'rule-package.open-dialog'],
  }),
  defineFeature({
    id: 'filing',
    machine: filingMachine,
    emits: [
      'filing.opened',
      'filing.facts-entered',
      'filing.calculation-requested',
      'filing.statement-handed-in',
      'filing.approved',
      'filing.submitted',
    ],
    handles: ['client.opened', 'rule-package.published'],
    accepts: [
      'filing.open',
      'filing.enter',
      'filing.request',
      'filing.hand-in',
      'filing.approve',
      'filing.submit',
      'filing.open-dialog',
    ],
  }),
  defineFeature({
    id: 'source-box',
    machine: sourceBoxMachine,
    emits: [],
    handles: ['filing.statement-handed-in'],
    accepts: ['source-box.observe'],
  }),
] as const;
